import React, {
  FC,
  Fragment,
  useEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import CellValidationAlert from '../CellValidationAlert';

type Props = {
  value: string,
  context: {
    accessFunctionOccurrences: { [key: string]: number },
    isDialogSubmitted: boolean
  },
};

const IpAFNameCellRenderer: FC<Props> = ({ value, context }: Props) => {
  const [isNameValid, setNameValid] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (value || context.isDialogSubmitted) {
      setNameValid(context?.accessFunctionOccurrences[value] <= 1 && value.length > 0 && value.length < 128);
    }
  }, [value, context]);

  const renderInvalidNameAlert = (isValid: boolean) => {
    if (isValid) {
      return null;
    }

    return (
      <Fragment>
        <CellValidationAlert msg={t('allowedIps.error.invalidAccessFunctionName')} />&nbsp;
      </Fragment>
    );
  };

  return (
    <div>
      {renderInvalidNameAlert(isNameValid)}{value}
    </div>
  );
};

export default IpAFNameCellRenderer;
